import { iconNavFechar } from '@bsds-lib-component/icons/icons';
import { BsdsIcon } from '@bsds-lib-component/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Defines the available semantic titles for the close button.
// CloseModal: Used when the button is inside a modal; it indicates closing the current modal only.
// CloseAndGoBack: Used on pages; it indicates closing the view and navigating back/home.
const CloseButtonTitle = {
  CloseModal: 'Fechar modal atual',
  CloseAndGoBack: 'Fechar e voltar',
} as const;

type CloseButtonTitleOption = typeof CloseButtonTitle[keyof typeof CloseButtonTitle];

type ButtonCloseProps = {
  onClick?: () => void;
  isModal?: boolean;
  // When provided, forces the title to the chosen semantic option regardless of isModal
  titleOption?: CloseButtonTitleOption;
  className?: string;
  // When provided and isModal is false, navigates to this path on click
  navigatePath?: string;
  // Uses history replace when navigating (optional)
  navigateReplace?: boolean;
};

function ButtonClose({ onClick, isModal = false, titleOption, className = '', navigatePath, navigateReplace = false }: ButtonCloseProps) {
  const baseClass = 'flex items-center justify-center w-10 h-10 bg-white rounded-full transition-all duration-200 text-gray-600 hover:text-primary-700 hover:bg-white hover:cursor-pointer shadow-xs';
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isModal) {
      e.preventDefault();
      e.stopPropagation();
      onClick?.();
      return;
    }

    onClick?.();

    if (navigatePath) {
      navigate(navigatePath, { replace: navigateReplace });
    }
  };

  const resolvedTitle: string = titleOption
    ? titleOption
    : (isModal ? CloseButtonTitle.CloseModal : CloseButtonTitle.CloseAndGoBack);

  return (
    <button
      onClick={handleClick}
      className={`${baseClass} ${className}`}
      title={resolvedTitle}
      aria-label={resolvedTitle}
      type="button"
    >
      <BsdsIcon icon={iconNavFechar} className="w-3 h-3" aria-hidden="true" />
    </button>
  );
}

export default ButtonClose;


